import React from 'react';
import SolutionInstallRequesContainer from 'containers/SolutionInstallRequesContainer';

export default function SolutionInstallRequestPage() {
  return <SolutionInstallRequesContainer />;
}
